import { useCallback } from 'react';
import _ from 'lodash';
import { useInterval } from './use-interval';
import { layoutDefaults } from '../utils/layout-defaults';

const shakeAnimation = [
  'animate__animated',
  'animate__headShake',
  'animate__fast',
];

function useShake(
  {
    element,
    enabled = true,
    loop = true,
    interval = layoutDefaults.shakeInterval,
  },
  deps = []
) {
  const stopAnimation = useCallback(() => {
    if (element != null) {
      element.classList?.remove(...shakeAnimation);
    }
  }, [element]);

  const shake = useCallback(() => {
    if (element != null) {
      element.classList?.add(...shakeAnimation);
      element.addEventListener('animationend', () => {
        stopAnimation();
      });
    }
  }, [element]);

  if (loop) {
    useInterval(shake, interval, enabled, [
      element,
      enabled,
      stopAnimation,
      ...deps,
    ]);
  } else if (enabled) {
    _.delay(shake, interval);
  }
}

export { useShake };
